const navigationEvents = {
  action: "navigation",
  labels: {
    dashboard: {
      styleQuiz: "dashboard:style-quiz",
      createRoom: "dashboard:create-room",
      myDesigns: "dashboard:my-designs",
      login: "dashboard:login",
      planner: "dashboard:planner",
      roomCapture: "dashboard:room-capture",
      learnMoreHero: "dashboard:learn-more-hero",
    },
    informationCards: {
      designCard: "card:start-design",
      findStoreCard: "card:find-your-store",
      captureCard: "card:capture:scan-your-room",
      captureBanner: "card:capture:banner",
    },
  },
};

export default navigationEvents;
